<template>
  <!-- agms -->
  <div class="w3-container w3-small" id="agms">
    <div class="w3-hide-large" style="margin-top:80px"></div>
    <h1 class="w3-xxlarge w3-text-black">
      <b>AGM /SGM.</b>
    </h1>
    <hr style="width:50px;border:5px solid black" class="w3-round" />
    <div></div>
    <div class="w3-clear">
      <div class="w3-responsive">
        <table class="w3-table-all">
          <caption @if="agms" style="text-align:left; font-size:medium">
            AGM / SGM{{
              agms.length > 0 ? " For Fiscal Year " + agms[0].fy : ""
            }}
          </caption>
          <thead class="w3-gray">
            <!-- <th class="nowrap">Date</th> -->
            <th class="nowrap">Stock Symbol</th>
            <!-- <th class="nowrap">CompanyName</th> -->
            <th class="nowrap">Meeting</th>
            <!-- <th class="nowrap">Fiscal Year</th> -->
            <th class="nowrap">Meeting Date</th>
            <th class="nowrap">Meeting Time</th>
            <th class="nowrap">Meeting Place</th>
            <th class="nowrap">Common Agenda</th>
            <th class="nowrap">Special Agenda</th>
            <!-- <th class="w3-align-right nowrap">Cash Dividend</th> -->
            <!-- <th class="w3-align-right nowrap">Stock Dividend</th> -->
            <th class="nowrap">Book Close Date</th>
            <th class="nowrap">BOD Date</th>
            <th class="nowrap">Notice Date</th>
            <th class="nowrap">Action</th>
          </thead>
          <tbody>
            <tr v-show="agmsloading">
              <td colspan="6">Loading...</td>
            </tr>
            <tr v-show="agmsmessage">
              <td colspan="6">{{ agmsmessage }}</td>
            </tr>
            <tr
              v-show="!agmsloading"
              v-for="agm in agms"
              v-bind:key="agm.stockSymbol + agm.agmDate"
            >
              <!-- <td class="w3-left-align nowrap">{{ agm.tradedate }}</td> -->
              <td class="nowrap">
                <span :title="agm.companyName">{{ agm.stockSymbol }}</span>
              </td>
              <!-- <td class="nowrap">{{agm.companyName }}</td> -->
              <td class="wrap" v-html="agm.meetingType"></td>
              <!-- <td class="nowrap">{{ agm.fy }}</td>    -->
              <td class="nowrap">{{ agm.agmDate }}</td>
              <td class="nowrap">{{ agm.meetingTime }}</td>
              <td class="wrap" v-html="agm.meetingPlace"></td>
              <td class="wrap" v-html="agm.commonAgenda"></td>
              <td class="wrap" v-html="agm.specialAgenda"></td>
              <!-- <td class="w3-right-align nowrap">{{ agm.cashDividend }}</td> -->
              <!-- <td class="w3-right-align nowrap">{{ agm.stockDividend }}</td> -->
              <td class="nowrap">{{ agm.bookCloseDate }}</td>
              <td class="nowrap">{{ agm.bodMeetingDate }}</td>
              <td class="nowrap">{{ agm.publicNoticeDate }}</td>
              <td>
                <button @click="exportText(agm)">
                  <i class="fa fa-download"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import DataService from "@/services/DataService";
import { saveAs } from "file-saver";
import moment from "moment";

export default {
  name: "Agms",
  components: {},
  data() {
    return {
      agms: [],
      selectedFy: "",
      agmsloading: false,
      agmsmessage: "",
    };
  },
  methods: {
    async getAgms() {
      this.agmsloading = true;
      this.agmsmessage = "";
      const response = await DataService.getAgmsFromApi(this.selectedFy);
      if (response.data) {
        this.agms = response.data;
        if (this.agms.length > 0) {
          this.selectedFy = this.agms[0].fy;
          this.agmsmessage = "";
        } else {
          this.agmsmessage = "No Data Found";
        }
      }
      this.agmsloading = false;
    },
    formatDate(date) {
      return moment(String(date), "YYYY-MM-DD").format("YYYYMMDD");
    },
    exportText(agm) {
      var date = this.formatDate(new Date().toISOString().slice(0, 10));

      var blob = new Blob(
        [
          `Subject                          :Nmeet
Date                             :${date}
Segname                          :NMEET.TXT
Stock code                       :${agm.stockSymbol}
Security Short Name              :${agm.companyName}
Financial YEAR                   :${agm.fyStartDate} to ${agm.fyEndDate}
Book Closure Period              :${this.formatDate(
            agm.bookCloseDate
          )} to ${this.formatDate(agm.agmDate)}
Record date                      :${this.formatDate(
            moment(agm.bookCloseDate, "YYYY-MM-DD")
              .add(-1, "days")
              .toISOString()
          )}
Meeting Type                     :${agm.meetingType}
Meeting Date                     :${this.formatDate(agm.agmDate)}
Time                             :${agm.meetingTime}
Place                            :${agm.meetingPlace}
CommonAgenda                     :${agm.commonAgenda}


Special Agenda                   :${agm.specialAgenda}



Note:${agm.companyName}. called it's ${
            agm.meetingType
          } AGM as mentioned above details decided by 
      it's BOD meeting dated ${agm.bodMeetingDate} and publicly notified on ${
            agm.publicNoticeDate
          }.
`,
        ],
        {
          type: "text/plain;charset=utf-8",
        }
      );
      saveAs(blob, `NMEET${date}-${agm.stockSymbol}.txt`);
    },
  },
  created() {
    this.getAgms();
  },
};
</script>

<style></style>
